import { VAlert } from 'vuetify/lib/components/VAlert';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VAlert,{staticClass:"text-center",attrs:{"dense":"","type":_vm.roleHolder ? 'info':'warning',"width":"100%"}},[_c('div',[_vm._v(" The "+_vm._s(_vm.role)+" role is currently "+_vm._s(_vm.roleHolder ? '':'not')+" being fulfilled by "+_vm._s(_vm.roleHolder ? _vm.roleHolder.name :'anyone')+" "),(_vm.roleHolder)?_c('div',[_vm._v(_vm._s(_vm.roleHolder.mobile ? '('+_vm.roleHolder.mobile+')' :''))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }